import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulosMenuComponent } from './modulos-menu.component';
import { FormsModule } from '@angular/forms';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';

@NgModule({
  declarations: [ModulosMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxGridModule,
  ],
  exports: [ModulosMenuComponent],
})
export class ModulosMenuModule {}
